import JobRequestPage from "Channelpartner/layout/JobRequestPage";
import Channlpartnerdashboard from "Channelpartner/layout/channlpartendashboard";
import CandidatesList from "Channelpartner/layout/CandidatesList";
import Assistant from "Channelpartner/layout/Assistant";
import Mis from "Channelpartner/layout/Mis";
import people from "../assets/images/people.png";
import post from "../assets/images/post.png";
import CoursesAssigned from "Channelpartner/layout/CoursesAssigned";
import StudentList from "Channelpartner/layout/StudentList";

const channelpartnerroute = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       xmlnsXlink="http://www.w3.org/1999/xlink"
  //       width="15"
  //       height="15"
  //       viewBox="0 0 15 15"
  //       fill="none"
  //     >
  //       <rect width="15" height="15" fill="url(#pattern0)" />
  //       <defs>
  //         <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
  //           <use xlinkHref="#image0_1325_7337" transform="scale(0.0078125)" />
  //         </pattern>
  //         <image
  //           id="image0_1325_7337"
  //           width="128"
  //           height="128"
  //           xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADsQAAA7EB9YPtSQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAILSURBVHic7dwxTsNAFAbhH3rEBeiTq1MAaSm4UaQo4QChgDRI1i7E611n5pPcRfKzPUI0bxNJkiRJkqR12SbZJTklOTe+TknekmwWeTIVbZMc0v7D/74OMYIh7LL8x79cLws8X1N3vQeYwSnJQ8d7P3a69yxuIYBz5/uv+h3e9x5AfRkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGcAyPL+goV6r4ZerxPMLGhs9gKHPL1j1avOPmo/QUukdDn1+gQFcr/QOh57PfwLhDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOBqA3C/HWz0/fbR18NHn69o6P32jrPdRAA16+FD77dnpsqvsOr18JoAhn6AOF+J5wNomgHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQBcTQCfzaeYdqz4jfNNK85XE8DHDIP813vFb5xvWs18RZv0OSx6n+TJ+ZrPV2WT5DXff1JaD35M8vzH4Z3vuvkkSZIkSRLAF6n8j8U8ueBzAAAAAElFTkSuQmCC"
  //         />
  //       </defs>
  //     </svg>
  //   ),
  //   route: "/dashboard",
  //   component: <Mis />,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Courses Assigned",
    key: "courses-assigned",
    icon: (
      <div width="12px" height="15px">
        <img src={post} alt="dashboard_icon" />
      </div>
    ),
    route: "/courses-assigned",
    component: <CoursesAssigned />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Candidates",
    key: "candidates-list",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
      >
        {/* <circle cx="17" cy="17" r="16.75" fill="white" stroke="#C6C6C6" strokeWidth="0.5" /> */}
        <path
          d="M23 13.16C22.94 13.15 22.87 13.15 22.81 13.16C21.43 13.11 20.33 11.98 20.33 10.58C20.33 9.15 21.48 8 22.91 8C24.34 8 25.49 9.16 25.49 10.58C25.48 11.98 24.38 13.11 23 13.16Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.9703 20.4402C23.3403 20.6702 24.8503 20.4302 25.9103 19.7202C27.3203 18.7802 27.3203 17.2402 25.9103 16.3002C24.8403 15.5902 23.3103 15.3502 21.9403 15.5902"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9705 13.16C11.0305 13.15 11.1005 13.15 11.1605 13.16C12.5405 13.11 13.6405 11.98 13.6405 10.58C13.6405 9.15 12.4905 8 11.0605 8C9.63047 8 8.48047 9.16 8.48047 10.58C8.49047 11.98 9.59047 13.11 10.9705 13.16Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0004 20.4402C10.6304 20.6702 9.12043 20.4302 8.06043 19.7202C6.65043 18.7802 6.65043 17.2402 8.06043 16.3002C9.13043 15.5902 10.6604 15.3502 12.0304 15.5902"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.0001 20.6288C16.9401 20.6188 16.8701 20.6188 16.8101 20.6288C15.4301 20.5788 14.3301 19.4488 14.3301 18.0488C14.3301 16.6188 15.4801 15.4688 16.9101 15.4688C18.3401 15.4688 19.4901 16.6288 19.4901 18.0488C19.4801 19.4488 18.3801 20.5888 17.0001 20.6288Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0897 23.7794C12.6797 24.7194 12.6797 26.2594 14.0897 27.1994C15.6897 28.2694 18.3097 28.2694 19.9097 27.1994C21.3197 26.2594 21.3197 24.7194 19.9097 23.7794C18.3197 22.7194 15.6897 22.7194 14.0897 23.7794Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    route: "/candidates-list",
    component: <StudentList />,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Phygital Volunteer",
  //   key: "phygitalvolunteer",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="30"
  //       height="30"
  //       viewBox="0 0 309 279"
  //       fill="none"
  //     >
  //       <path
  //         d="M212.44 58.37H94.89V112.21C94.89 128.6 101.6 143.51 112.41 154.31C123.21 165.11 138.12 171.82 154.51 171.82C170.79 171.82 185.6 165.21 196.49 154.43C199.22 151.69 201.59 148.84 203.69 145.78H181.1C179.95 149.05 177.69 151.93 174.64 154.17C170.57 157.17 165.03 159.03 158.99 159.03C152.95 159.03 147.4 157.17 143.34 154.17C138.82 150.84 136.03 146.11 136.03 140.78C136.03 135.45 138.83 130.72 143.34 127.39C147.41 124.39 152.95 122.53 158.99 122.53C165.03 122.53 170.58 124.39 174.64 127.39C177.68 129.63 179.94 132.51 181.1 135.78H209.23C212.38 128.54 214.12 120.57 214.12 112.21V58.34L212.45 58.37H212.44ZM84.89 53.23C84.93 38.63 90.92 25.35 100.57 15.69C110.26 6 123.6 0 138.26 0H260.81C263.57 0 265.81 2.24 265.81 5C265.81 19.65 259.81 32.99 250.13 42.68C243.09 49.72 234.11 54.81 224.11 57.07V101.29H228.7C234.8 101.29 240.36 103.79 244.39 107.82C248.43 111.87 250.94 117.43 250.94 123.53C250.94 129.65 248.44 135.22 244.41 139.24C240.38 143.27 234.82 145.77 228.71 145.77H215.43C212.24 151.51 208.28 156.76 203.67 161.36L203.37 161.63C190.77 174.09 173.48 181.8 154.5 181.8C135.35 181.8 117.94 173.97 105.33 161.36C92.72 148.75 84.89 131.34 84.89 112.19V53.21V53.23ZM168.74 135.43C166.31 133.64 162.86 132.52 158.98 132.52C155.1 132.52 151.65 133.63 149.22 135.43C147.24 136.89 146.01 138.79 146.01 140.78C146.01 142.76 147.24 144.67 149.22 146.13C151.65 147.92 155.1 149.04 158.98 149.04C162.86 149.04 166.31 147.93 168.74 146.13C170.69 144.69 171.91 142.83 171.95 140.74C171.91 138.74 170.69 136.88 168.74 135.44V135.43ZM219.98 135.78H228.71C232.06 135.78 235.12 134.4 237.34 132.18C239.56 129.96 240.94 126.9 240.94 123.54C240.94 120.17 239.56 117.1 237.35 114.89C235.14 112.68 232.07 111.3 228.7 111.3H224.11V112.21C224.11 120.47 222.65 128.41 219.98 135.78ZM124.68 191.04H226.59C249.26 191.04 269.87 200.32 284.8 215.24C299.74 230.18 309.01 250.79 309.01 273.46C309.01 276.22 306.77 278.46 304.01 278.46H5C2.24 278.46 0 276.22 0 273.46C0 250.8 9.27 230.2 24.2 215.26C39.16 200.31 59.76 191.04 82.42 191.04H124.68Z"
  //         fill="black"
  //       />
  //     </svg>
  //   ),
  //   route: "/phygitalvolunteer",
  //   component: <Assistant />,
  //   noCollapse: true,
  // },
];

export default channelpartnerroute;
